import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'email-verification-message',
  templateUrl: './email-verification-message.component.html',
  styleUrls: ['./email-verification-message.component.scss'],
})
export class EmailVerificationMessageComponent {
  @Input() email?: string;
}
